// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3VWou","modalForm":"UpgradeEpcsModal_modalForm__dOH9D","modalFooter":"UpgradeEpcsModal_modalFooter__Pq_oZ"};